const WALLYFRAME_FAVORITES_KEY = 'wallyframe:favorites:v1';
const WALLYFRAME_LAST_VISIT_KEY = 'wallyframe:last-visit:v1';

function readFavorites() {
  try {
    const value = JSON.parse(localStorage.getItem(WALLYFRAME_FAVORITES_KEY) || '[]');
    return new Set(Array.isArray(value) ? value : []);
  } catch {
    return new Set();
  }
}

function writeFavorites(favorites) {
  try {
    localStorage.setItem(WALLYFRAME_FAVORITES_KEY, JSON.stringify([...favorites]));
  } catch {
    return;
  }
}

function syncFavoriteButtons(scope, favorites) {
  scope.querySelectorAll('[data-wf-favorite]').forEach((button) => {
    const isSaved = favorites.has(button.dataset.wfKey);
    button.setAttribute('aria-pressed', String(isSaved));
    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-label', isSaved ? button.dataset.wfRemoveLabel : button.dataset.wfSaveLabel);
    const label = button.querySelector('[data-wf-favorite-label]');
    if (label) label.textContent = isSaved ? button.dataset.wfSavedText : button.dataset.wfSaveText;
  });
}

function announceFavoriteCounts(favorites) {
  document.querySelectorAll('[data-wf-saved-count]').forEach((count) => {
    count.textContent = String(favorites.size);
  });
  document.dispatchEvent(new CustomEvent('wallyframe:favorites', { detail: { count: favorites.size } }));
}

function toggleFavorite(button) {
  const favorites = readFavorites();
  const key = button.dataset.wfKey;
  if (!key) return;
  if (favorites.has(key)) favorites.delete(key);
  else favorites.add(key);
  writeFavorites(favorites);
  syncFavoriteButtons(document, favorites);
  announceFavoriteCounts(favorites);
}

function markNewCards(section) {
  let lastVisit = 0;
  try {
    lastVisit = Number(localStorage.getItem(WALLYFRAME_LAST_VISIT_KEY) || 0);
  } catch {
    lastVisit = 0;
  }

  section.querySelectorAll('[data-wf-card]').forEach((card) => {
    const published = Number(card.dataset.wfPublished || 0) * 1000;
    const badge = card.querySelector('[data-wf-new]');
    if (badge) badge.hidden = lastVisit > 0 && published <= lastVisit;
  });

  window.setTimeout(() => {
    try {
      localStorage.setItem(WALLYFRAME_LAST_VISIT_KEY, String(Date.now()));
    } catch {
      return;
    }
  }, 3000);
}

function initDiscovery(section) {
  if (section.dataset.wfReady === 'true') return;
  section.dataset.wfReady = 'true';

  const cards = [...section.querySelectorAll('[data-wf-card]')];
  const dialog = section.querySelector('[data-wf-dialog]');
  const dialogContent = dialog?.querySelector('[data-wf-dialog-content]');
  const dialogStatus = dialog?.querySelector('[data-wf-dialog-status]');
  const filterButton = section.querySelector('[data-wf-filter-saved]');
  const emptyState = section.querySelector('[data-wf-saved-empty]');
  let activeIndex = 0;

  const updateFilter = () => {
    if (!filterButton) return;
    const favorites = readFavorites();
    const filterActive = filterButton.getAttribute('aria-pressed') === 'true';
    let visibleCount = 0;
    cards.forEach((card) => {
      const visible = !filterActive || favorites.has(card.dataset.wfKey);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    if (emptyState) emptyState.hidden = !filterActive || visibleCount > 0;
    filterButton.querySelector('[data-wf-filter-label]').textContent = filterActive
      ? filterButton.dataset.wfAllText
      : filterButton.dataset.wfSavedText;
  };

  const renderDialog = (index) => {
    if (!dialog || !dialogContent || cards.length === 0) return;
    activeIndex = (index + cards.length) % cards.length;
    const template = cards[activeIndex].querySelector('template[data-wf-template]');
    if (!template) return;
    dialogContent.replaceChildren(template.content.cloneNode(true));
    syncFavoriteButtons(dialogContent, readFavorites());
    if (dialogStatus) {
      dialogStatus.textContent = dialogStatus.dataset.wfStatus
        .replace('[current]', String(activeIndex + 1))
        .replace('[total]', String(cards.length));
    }
  };

  const openDialog = (index) => {
    renderDialog(index);
    if (dialog && !dialog.open) dialog.showModal();
  };

  section.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-wf-favorite]');
    if (favorite) {
      event.preventDefault();
      toggleFavorite(favorite);
      updateFilter();
      return;
    }

    const opener = event.target.closest('[data-wf-open]');
    if (opener) {
      const card = opener.closest('[data-wf-card]');
      openDialog(cards.indexOf(card));
      return;
    }

    if (event.target.closest('[data-wf-random]')) {
      const visibleCards = cards.filter((card) => !card.hidden);
      const pool = visibleCards.length > 0 ? visibleCards : cards;
      const chosen = pool[Math.floor(Math.random() * pool.length)];
      openDialog(cards.indexOf(chosen));
      return;
    }

    if (event.target.closest('[data-wf-filter-saved]')) {
      const active = filterButton.getAttribute('aria-pressed') === 'true';
      filterButton.setAttribute('aria-pressed', String(!active));
      updateFilter();
      return;
    }

    if (event.target.closest('[data-wf-dialog-close]')) dialog?.close();
    if (event.target.closest('[data-wf-dialog-previous]')) renderDialog(activeIndex - 1);
    if (event.target.closest('[data-wf-dialog-next]')) renderDialog(activeIndex + 1);
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') renderDialog(activeIndex - 1);
    if (event.key === 'ArrowRight') renderDialog(activeIndex + 1);
  });

  document.addEventListener('wallyframe:favorites', updateFilter);
  markNewCards(section);
  const favorites = readFavorites();
  syncFavoriteButtons(section, favorites);
  announceFavoriteCounts(favorites);
  updateFilter();
}

function initRoomPreview(section) {
  if (section.dataset.wfReady === 'true') return;
  section.dataset.wfReady = 'true';
  const frame = section.querySelector('[data-wf-room-frame]');
  const sizeOutput = section.querySelector('[data-wf-room-size]');

  const setSize = (button) => {
    const width = Number(button.dataset.wfWidth || 30);
    const height = Number(button.dataset.wfHeight || 40);
    const longestEdge = Math.max(width, height);
    const displayWidth = Math.min(44, 16 + longestEdge * 0.28);
    frame?.style.setProperty('--wf-room-frame-width', `${displayWidth}%`);
    if (frame) frame.style.aspectRatio = `${width} / ${height}`;
    section.querySelectorAll('[data-wf-room-size-button]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
    if (sizeOutput) sizeOutput.textContent = button.textContent.trim();
  };

  section.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('[data-wf-room-size-button]');
    if (sizeButton) setSize(sizeButton);
    const favorite = event.target.closest('[data-wf-favorite]');
    if (favorite) toggleFavorite(favorite);
  });

  const firstSize = section.querySelector('[data-wf-room-size-button]');
  if (firstSize) setSize(firstSize);
  const favorites = readFavorites();
  syncFavoriteButtons(section, favorites);
  announceFavoriteCounts(favorites);
}

function initWallyFrameExperience(root = document) {
  root.querySelectorAll('[data-wf-discovery]').forEach(initDiscovery);
  root.querySelectorAll('[data-wf-room]').forEach(initRoomPreview);
}

initWallyFrameExperience();
document.addEventListener('shopify:section:load', (event) => initWallyFrameExperience(event.target));
